import { Flex, Group, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Publication } from '@/module/Author/Publication/model/PublicationTypes';

import { NotEditable } from '@/core/components';

import { PublishedAtText, Source, WosIndexAt } from '@feature/utils';

interface PublicationTitleGroupProps {
  publication: Publication;
  authorsNo: number;

  actions: ReactNode;

  titlePre?: ReactNode;
}

export function PublicationHeader({ publication, authorsNo, actions, titlePre }: PublicationTitleGroupProps) {
  const { title, publishedAt, source, wosIndexingYear } = publication;
  const { t } = useTranslation();

  return (
    <Flex
      justify="space-between"
      gap="10px"
    >
      <Stack gap="xs">
        <Group gap="3px">
          {titlePre}
          <Text fw="500">{title}</Text>
        </Group>
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <WosIndexAt year={wosIndexingYear} />
          <Text
            size="sm"
            c="dimmed"
          >
            {authorsNo} {t('articles.noOfAuthors')}
          </Text>
        </Group>
      </Stack>
      {source?.type !== 'WOS' && (
        <Group>
          <Source source={source} />
          {actions}
        </Group>
      )}
      {source?.type == 'WOS' && (
        <Stack align="center">
          <Source source={source} />
          <NotEditable tooltip={t('publications.wosNotEditable')} />
        </Stack>
      )}
    </Flex>
  );
}
